import { formatDate } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateService } from "@ngx-translate/core";
import { concat, Observable, of, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  take,
} from "rxjs/operators";
import { LabelMode } from "src/utils/label-mode.enum";
import { GenerateRandom } from "src/utils/random";
import * as _ from "underscore";

@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class SelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  _query = {};
  _isDisabled: boolean;
  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input()
  set error(value: any) {
    this.isError = false;
    if (value) {
      this.isError = true;
    }
  }

  @Input() set labelMode(value: LabelMode) {
    this.mode = value;
  }

  @Input() checkboxModel = false;

  @Input() appendTo: string | null = "body";
  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() addonLabel: string;
  @Input() addonLabelClass: string;
  @Input() placeholder = "";
  @Input() bindLabel = "name";
  @Input() bindValue = "id";
  @Input() ignoreValue: any[] = [];
  @Input() groupBy: String;
  @Input() isMultiple: boolean = false;

  @Input() options: any = [];
  @Input() url: string;
  @Input() limit: string = "50";
  @Input() disabledLimit: boolean = false;
  @Input() clearSearchOnAdd: boolean = true;

  @Input() inputClass: string;
  @Input() classes: string;
  @Input() errorMessage: string = "VALIDATOR.PLEASE_SELECT";
  @Input() clearable: boolean = true;
  @Input() searchable = true;
  @Input() fetchable = false;
  @Input() required: boolean = false;

  @Input() selectableGroup: boolean = false;
  @Input() selectableGroupAsModel: boolean = true;
  @Input() closeOnSelect: boolean = true;
  @Input() noneDisplayBadgeSelectGroup = false;

  // @Input()
  // set options(value: Array<any>) {
  //   this.options$ = of(value);
  // }

  @Input() set query(value: any) {
    this._query = value;
    setTimeout(() => {
      this.getItems();
    }, 100);
  }

  @Output() keywordChange = new EventEmitter();
  @Output() objectChange = new EventEmitter();

  @Output() valueChange = new EventEmitter();
  @Output() inputChange = new EventEmitter();
  @Output() cancelChange = new EventEmitter();
  @Output() applyChange = new EventEmitter();

  LabelMode = LabelMode;
  mode: LabelMode = LabelMode.DEFAULT;
  keyword: string | null = null;

  form = new FormControl();
  subscription: Subscription;
  searchSubscription: Subscription;

  options$: Observable<Array<any>> = of([]);
  search$ = new Subject<string>();
  isLoading = false;
  isError = false;

  onChange = (value: string) => { };
  onTouched = (value: string) => { };

  #http = inject(HttpClient);
  #translate = inject(TranslateService);
  #cdr = inject(ChangeDetectorRef);
  // private errMsgService: ErrorMassageService,
  // private memberService: MemberService

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ignoreValue?.currentValue) {
      this.getItems();
    }
  }

  ngOnInit(): void {
    console.log('append', this.appendTo);

    this.subscription = this.form.valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap(() => {
          return this.options;
        }),
      )
      .subscribe((value) => {
        if (value) {
          // const obj_find = value.find(
          //   (i) => i[this.bindValue] === this.form.value
          // );
          // if (obj_find) {
          //   this.objectChange.emit(obj_find);
          // }
        }
        this.onChange(this.form.value);
        this.returnValueChange();
      });

    // if (this.fetchable) {
    //   this.setTypeahead();
    // }
  }

  onInputChange(value: any) {
    this.inputChange.emit(value);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  writeValue(obj: any): void {
    this.form.setValue(obj);
    this.getItems();
  }
  onClearSelected() {
    if (this.isMultiple && this.selectableGroup) {
      this.options = this.url ? [] : this.options;
      this.form.setValue(null);
    }
    this.getItems();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSearch(term: any) {
    this.keyword = term.term;
    if (this.isMultiple && this.selectableGroup) {
      this.options = this.url ? [] : this.options;
      this.form.setValue(null);
    }
    this.getItems();
  }
  onSearchFn = (term: string, item: any): boolean => {
    if (!this.url) {
      item[this.bindLabel] = item[this.bindLabel].replace(",", "");
      term = term.toLocaleLowerCase();
      return item[this.bindLabel].toLocaleLowerCase().indexOf(term) > -1;
    } else {
      return true;
    }
  };

  async getItems() {
    if (this.url) {
      let headers;
      const params = this.setParams({
        ...this._query,
        limit: this.limit,
        keywords: this.keyword,
      });
      this.keyword = "";
      let response: any;
      //custom for member register
      // if (this.memberService.getSessionToken()) {
      //   headers = new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: this.memberService.getSessionToken(),
      //   });
      //   response = await this.http$
      //     .get(this.url, { params, headers })
      //     .toPromise();
      // } else {
      // }
      response = await this.#http.get(this.url, { params }).toPromise();
      //end
      this.options = response
        .map((item: any) => {
          if (item[this.bindLabel]) {
            item[this.bindLabel] = this.#translate.instant(
              item[this.bindLabel],
            );
          }
          return item;
        })
        .filter((item: any) => {
          return !this.ignoreValue?.includes(item[this.bindValue]);
        });

      this.returnValueChange();

      this.#cdr.detectChanges();
    }
  }

  returnValueChange() {
    if (this.isMultiple && Array.isArray(this.form.value)) {
      const map = this.form.value.map((element) => {
        return this.options.find(
          (item: any) => item[this.bindValue] === element,
        );
      });

      if (!this.selectableGroup || this.noneDisplayBadgeSelectGroup) {
        this.valueChange.emit(map);
      }
    } else {
      const find = _.find(
        this.options,
        (item: any) => item[this.bindValue as any] === this.form.value,
      );

      this.valueChange.emit(find);
    }
  }

  setDisabledState?(isDisabled: boolean): void { }
  toggleCheckAll(value: any) {
    if (value) {
      this.form.patchValue(this.options.map((x: any) => x[this.bindValue]));
      this.inputChange.emit(this.options);
    } else {
      this.form.patchValue(null);
      this.inputChange.emit([]);
    }
  }
  onSelectClick() { }

  setParams(object: any) {
    let _params: any = {};
    for (let key in object) {
      if (object[key] != null) {
        if (object[key] instanceof Date) {
          _params[key] = formatDate(object[key], "YYYY-MM-dd", "th");
        } else {
          _params[key] = object[key];
        }
      }
    }
    if (this.disabledLimit) {
      delete _params.limit;
    }

    return _params;
  }

}
